<template>
  <div class="card text-white text-left mb-5">
    <div class="maskot">
      <img src="~@/assets/img/maskot.png" class="maskot-img">
    </div>
    <div class="card-body monaco pt-5">
      <details>
        <summary><strong>Case 7: Menghitung Huruf pada Posisi Genap dalam Kata</strong></summary>
        <p>
          <br>
          <strong>Story</strong>: <br>
          Lisa tengah kesulitan mengerjakan Tugas Pemrograman.
          Lisa diminta membuat program yang dapat menghitung jumlah huruf dalam setiap paragraf,
          sekaligus Lisa diminta untuk menghitung jumlah huruf pada posisi <strong class="text-danger">Genap</strong> dalam setiap kata.
          Dengan asumi kata pertama dimulai dari posisi 0. <br><br>
          Bantulah Lisa agar dapat menyelesaikan tugasnya dengan baik.

          <br><br>
          <strong>Contoh <em>input</em> 1</strong>: <br>
          <pre>
            kata: makan
          </pre>
          <strong>Contoh <em>output</em> 1</strong>: <br>
          <pre>
            2
          </pre>

          <strong>Contoh <em>input</em> 2</strong>: <br>
          <pre>
            kata: bersepeda
          </pre>
          <strong>Contoh <em>output</em> 2</strong>: <br>
          <pre>
            4
          </pre>
        </p>
      </details>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      nama: '',
      kelas: '',
      jawaban: '',
      submited: false,
      sending: false,
    }
  },

  methods: {
    async submitAnswer() {
      this.sending = true
      let { data, error } = await this.$supabase
      .from('score2023')
      .insert([
        {
          email: this.email,
          nama: this.nama,
          kelas: this.kelas,
          jawaban: this.jawaban,
          case: 2
        }
      ])

      this.sending = false
      if (data) {
        this.submited = true
        this.email = ''
        this.nama = ''
        this.kelas = ''
        this.jawaban = ''
      }
    }
  }
};
</script>

<style scoped>
details {
  margin: 20px 0 20px 0;
}
pre {
  padding: 20px;
  padding-left: 0;
  padding-right: 0;
  color: #fff;
  background-color: #0b0b0b;
  border-top: 3px solid #fff;
  border-bottom: 3px solid #fff;
}
</style>
